import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: null,
  reducers: {
    resetUserSlice(state, action) {
      return null;
    },
    login(state, action) {
      return action.payload;
    },
    logout(state, action) {
      return null;
    },
  },
});

const { actions, reducer } = userSlice;
export const { login, logout, resetUserSlice } = actions;
export default reducer;
